<script>
import Layout from "../../layouts/main";
import Banner from "@/components/banner.vue"
import FaqS from "@/components/faqComponent.vue"


export default ({
  name: "Return",

  components: {
    Layout, Banner ,FaqS
  },

  props: {
   
    },

    data() {
        return{
            isCollapsed: []  ,

            open: false
        }
    },
   

  mounted() {
   
  },

  
  methods: {

    toggleCollapse(index) {

      this.$set(this.isCollapsed, index, !this.isCollapsed[index]);

    } ,


  },
      
});


</script>

<template>
  <Layout>
    <Banner pageTitle="ECHANGES D'ARTICLES" subtitle1=" " subtitle2=" " :small="true" ></Banner>

    <div class="row m-4 p-4">
      <div class="col-12 text-dark font-size-16">

        <p class="text-justify" style="line-height: 30px;
    letter-spacing: 1px;">Nous espérons que vous apprécierez tous vos achats commandés depuis notre Site Web,&nbsp;Essayez les chez vous ; vous disposez d’un délai de 15 jours après la date de livraison pour demander un échange si vous le désirez &nbsp;:</p>

      </div>
    </div>

    <FaqS title="ECHANGES D'ARTICLES" :faqType="2" > </FaqS>

    

  </Layout>
</template>
<style scoped>


</style>
